import converter from '@Ravnur-Inc/core/filters/date';

export default function toString(outputFormat = 'YYYY-MM-DD') {
  return function _convertDate(date: Date, fromUTC = true): string {
    return converter(date, outputFormat, fromUTC);
  };
}
